




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Product } from '@/models/catalog/Product';
import { GetProductPrimaryImage } from '@/services/ImageService'; 

@Component
export default class ProductItem extends Vue {
    @Prop({ required: true })
    public product!: Product;

    @Prop()
    public currentCategorySlug!: string;

    @Prop()
    public currentSubCategorySlug!: string;

    @Prop({ default: false })
    public small!: boolean;

    protected getBackgroundImage
        = () => GetProductPrimaryImage(this.product)
}
